  
import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { 
    
  }

  //######################
  //authentication
  //######################
  cloudPost(userData: string){
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = { headers: headers };
    console.log("json string in api - " + userData)
    var userJSON = JSON.parse(userData)
    var cloudUrl = "https://us-central1-financeforleasingtobuy.cloudfunctions.net/saveLead"
    console.log("url and userdata")
    console.log(cloudUrl + " - " + JSON.parse(userData))
    console.log("first name - " + userJSON.first_name)
    return this.http.post(cloudUrl, userData).pipe(
      map(responseData => {
        console.log(responseData)
        return responseData;
      })
    );
  }


  authNetPost(userInfo:any, cardInfo:any, price:string){
    
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let options = { headers: headers };
    let apiName = "3g2uxtN97H3"
    let apiKey = "6pF4Z5q278R84DgR"
    let requestBody = {
      "createTransactionRequest": {
          "merchantAuthentication": {
              "name": apiName,
              "transactionKey": apiKey
          },
          "transactionRequest": {
              "transactionType": "authCaptureTransaction",
              "amount": price,
              "payment": {
                  "creditCard": {
                      "cardNumber":cardInfo.cardNumber,
                      "expirationDate":cardInfo.expirationDate,
                      "cardCode":cardInfo.cardCode
                  }
              },
              "billTo": {
                "firstName": userInfo.first_name,
                "lastName": userInfo.last_name       
            }
          },

      }
    }
    console.log("requestBody")
    console.log(JSON.stringify(requestBody))
    let authNetUrl = "https://api.authorize.net/xml/v1/request.api"
    return this.http.post(authNetUrl, requestBody, options).pipe(
      map(responseData => {
        console.log(responseData)
        return responseData;
      })
    );
  }

  getLops(){
    let getLopsUrl = "https://us-central1-financeforleasingtobuy.cloudfunctions.net/getLops"
    return this.http.get<any>(getLopsUrl).pipe(
      map(responseData => {
        console.log(responseData)
        return responseData;
      })
    );
  }

  updateLops(){
    let updateUrl = "https://us-central1-financeforleasingtobuy.cloudfunctions.net/callZohoLopUpdate"
    return this.http.get(updateUrl).pipe(
      map(responseData => {
        console.log(responseData)
        return responseData;
      })
    );
  }
}